import { render, staticRenderFns } from "./rescueFundTab.vue?vue&type=template&id=e6b760fc&lang=pug"
import script from "./rescueFundTab.vue?vue&type=script&lang=js"
export * from "./rescueFundTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports